import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    GET_BILLINGS: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/GET_BILLINGS'),
    BILLINGS_SUCCESS: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/BILLINGS_SUCCESS'),
    GET_RESTRICTIONS: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/GET_RESTRICTIONS'),
    RESTRICTIONS_SUCCESS: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/RESTRICTIONS_SUCCESS'),
    GET_PLANS: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/GET_PLANS'),
    PLANS_SUCCESS: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/PLANS_SUCCESS'),
    CHANGE_PLAN: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/CHANGE_PLAN'),
    ERROR: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/ERROR'),
    CLEAR_ERRORS: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/CLEAR_ERRORS'),
    SHOW_INFO_BAR: createAction('GLOBAL/PLAN_SUBSCRIPTIONS/SHOW_INFO_BAR'),
};
export const initialState = Map({
    restrictions: null,
    planSubscriptions: null,
    billing: null,
    isProcessing: false,
    error: false,
    subscriptionInfoBar: false,
    success: false,
});
const reducer = handleActions({
    [actions.GET_BILLINGS]: (state) => state.set('isProcessing', true),
    [actions.SHOW_INFO_BAR]: (state, action) => state.set('subscriptionInfoBar', action.payload),
    [actions.BILLINGS_SUCCESS]: (state, action) => state.merge({ billing: action.payload, isProcessing: false }),
    [actions.GET_RESTRICTIONS]: (state) => state.set('isProcessing', true),
    [actions.RESTRICTIONS_SUCCESS]: (state, action) => state.merge({ restrictions: action.payload, isProcessing: false }),
    [actions.GET_PLANS]: (state) => state.set('isProcessing', true),
    [actions.PLANS_SUCCESS]: (state, action) => state.merge({ planSubscriptions: action.payload, isProcessing: false }),
    [actions.CLEAR_ERRORS]: (state) => state.merge({ isProcessing: false, error: false }),
    [actions.ERROR]: (state) => state.merge({ isProcessing: false, error: true }),
}, initialState);
export const getDocumentRestrictions = (state) => {
    const statistics = state.planSubscriptions.getIn([
        'billing',
        'activeBilling',
        'statistics',
    ]);
    return ((statistics &&
        statistics.find((item) => item.operation === 'DOCUMENT_SENDING')) ||
        {});
};
export const getDocumentBoardRestrictions = () => {
    return {
        board: true,
    };
};
export const getDocumentSearchRestrictions = () => {
    return {
        search: true,
    };
};
export default reducer;
export const isProcessingSelector = (state) => state.planSubscriptions.get('isProcessing');
